import { useEffect, useState } from "react";
import {
  PARTNERSHIP_ANALYTICS_EVENTS,
  getCategoryLabel,
} from "../../../constants/automapPartnershipConstants";
import { trackPartnershipEvent } from "../../../services/automapPartnershipApi";
import { PartnerLeadFormModal } from "./PartnerLeadForm";
import "../../../styles/partnerships.css";

const DEFAULT_CTAS = [
  { category: "financing", label: "Consultar financiación", action: "financing_cta" },
  { category: "insurance", label: "Cotizar seguro", action: "insurance_cta" },
  { category: "soat", label: "Revisar SOAT", action: "soat_cta" },
  { category: "inspection", label: "Agendar peritaje", action: "inspection_cta" },
  { category: "transfer_service", label: "Ayuda con traspaso", action: "transfer_cta" },
];

export default function VehiclePartnerServices({
  listing,
  listingId,
  dealerId,
  sourcePage,
  emphasizeFinancing = false,
}) {
  const [activeCategory, setActiveCategory] = useState(null);

  useEffect(() => {
    trackPartnershipEvent(PARTNERSHIP_ANALYTICS_EVENTS.SERVICE_CARD_VIEWED, {
      sourceComponent: "vehicle_detail_services",
      listingId,
    });
  }, [listingId]);

  const vehicleContext = listing
    ? {
        make: listing.make,
        model: listing.model,
        year: listing.year,
        priceCop: listing.priceCop,
        city: listing.city,
      }
    : null;

  const openForm = (category, action) => {
    trackPartnershipEvent(PARTNERSHIP_ANALYTICS_EVENTS.SERVICE_CTA_CLICKED, {
      category,
      sourceComponent: "vehicle_detail_services",
      sourceAction: action,
      listingId,
    });
    setActiveCategory(category);
  };

  const ctas = [...DEFAULT_CTAS];
  if (emphasizeFinancing || listing?.financingAvailable) {
    ctas.sort((a, b) => (a.category === "financing" ? -1 : b.category === "financing" ? 1 : 0));
  }

  return (
    <section className="vehicle-partner-services">
      <h3>Servicios que podrías necesitar</h3>
      <p className="muted" style={{ fontSize: "0.85rem", marginBottom: "0.75rem" }}>
        Aliados externos — condiciones sujetas al proveedor. No reemplaza contacto con el concesionario.
      </p>
      <div className="vehicle-partner-services__grid">
        {ctas.map((cta) => (
          <button
            key={cta.category}
            type="button"
            className={cta.category === "financing" && emphasizeFinancing ? "is-emphasis" : undefined}
            onClick={() => openForm(cta.category, cta.action)}
          >
            {cta.label}
          </button>
        ))}
      </div>
      <PartnerLeadFormModal
        open={Boolean(activeCategory)}
        onClose={() => setActiveCategory(null)}
        category={activeCategory}
        listingId={listingId}
        dealerId={dealerId}
        defaultVehicleContext={vehicleContext}
        sourcePage={sourcePage}
        sourceComponent="vehicle_detail_services"
        sourceAction={activeCategory ? `${activeCategory}_cta` : null}
        defaultCity={listing?.city || ""}
      />
    </section>
  );
}

export function ChecklistPartnerCta({ itemId, category, listingId, dealerId, defaultVehicleContext }) {
  const [open, setOpen] = useState(false);
  if (!category) return null;
  return (
    <div className="checklist-partner-cta">
      <button
        type="button"
        onClick={() => {
          trackPartnershipEvent(PARTNERSHIP_ANALYTICS_EVENTS.SERVICE_CTA_CLICKED, {
            category,
            sourceComponent: "checklist_item",
            sourceAction: itemId,
          });
          setOpen(true);
        }}
      >
        Solicitar información de {getCategoryLabel(category).toLowerCase()}
      </button>
      <PartnerLeadFormModal
        open={open}
        onClose={() => setOpen(false)}
        category={category}
        listingId={listingId}
        dealerId={dealerId}
        defaultVehicleContext={defaultVehicleContext}
        sourcePage="/checklist-compra"
        sourceComponent="checklist_item"
        sourceAction={itemId}
      />
    </div>
  );
}
